import { Machine_getNameOrCode, strIContains } from "../Shared/Shared.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { CustomerGroupWithMembers, CustomerInfo } from "../Shared/ApiDataTypes.js";
import { sortBy, map, singleton, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { memo, createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { hierarchyContext, Message, dispatchContext } from "../CompanyHierarchyContext.js";
import { RouterModule_nav, RouterModule_urlSegments } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { toArray, ofArray, append, empty, tail, head, isEmpty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Route_$007CInt$007C_$007C } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Components_CompanyHierarchyItem_Z538FBA19 } from "./CompanyHierarchyItem.js";
import { createObj, comparePrimitives, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { IconButton, Tooltip, Typography, ListItemText, ListItem, List, Collapse } from "@mui/material";
import { tryGetById, debounce as debounce_1, useResponsive } from "../Utils.js";
import PushPin from "@mui/icons-material/PushPin";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import MenuOpen from "@mui/icons-material/MenuOpen";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import Close from "@mui/icons-material/Close";
import { Components_Searchbar_25F45B5E } from "./Searchbar.js";
import { listLoadingIndicator } from "../ViewHelpers.js";
import { Components_TreeContainer_4089C375 } from "./TreeContainer.js";
import People from "@mui/icons-material/People";

function Helpers_filterMachines(searchTerm, machine) {
    const contains = (str_1) => strIContains(searchTerm, str_1);
    if (isNullOrWhiteSpace(searchTerm) ? true : contains(machine.Name)) {
        return true;
    }
    else {
        return contains(machine.SerialNumber);
    }
}

function Helpers_filterCustomers(searchTerm, customer) {
    const keep = isNullOrWhiteSpace(searchTerm) ? true : strIContains(searchTerm, customer.Name);
    const filteredMachines = keep ? customer.Machines : customer.Machines.filter((machine) => Helpers_filterMachines(searchTerm, machine));
    if (keep ? true : !(filteredMachines.length === 0)) {
        return new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, filteredMachines, customer.MarketCategories, customer.Groups);
    }
    else {
        return undefined;
    }
}

function Helpers_collectFavorites(group) {
    if (group.Favorite) {
        return group;
    }
    else {
        const customers = choose((customer) => {
            const machines = customer.Machines.filter((_arg) => _arg.Favorite);
            if (customer.Favorite) {
                return customer;
            }
            else if (!(machines.length === 0)) {
                return new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, machines, customer.MarketCategories, customer.Groups);
            }
            else {
                return undefined;
            }
        }, group.Customers);
        if (!(customers.length === 0)) {
            return new CustomerGroupWithMembers(group.Id, group.Name, group.Enabled, group.IsMain, group.IsPtg, group.Favorite, group.Company, customers);
        }
        else {
            return undefined;
        }
    }
}

function Components_MachineItem_6F13676(components_MachineItem_6F13676InputProps) {
    let activePatternResult, activePatternResult_1, activePatternResult_2, id, pathCustomerId, pathGroupId;
    const machine = components_MachineItem_6F13676InputProps.machine;
    const customerId = components_MachineItem_6F13676InputProps.customerId;
    const groupId = components_MachineItem_6F13676InputProps.groupId;
    const key = components_MachineItem_6F13676InputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const dispatch = reactApi.useContext(dispatchContext);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const machineName = Machine_getNameOrCode({
        code: machine.Code,
        name: machine.Name,
    });
    const patternInput = !isEmpty(currentUrl) ? ((head(currentUrl) === "group") ? (!isEmpty(tail(currentUrl)) ? ((activePatternResult = Route_$007CInt$007C_$007C(head(tail(currentUrl))), (activePatternResult != null) ? (!isEmpty(tail(tail(currentUrl))) ? ((head(tail(tail(currentUrl))) === "customer") ? (!isEmpty(tail(tail(tail(currentUrl)))) ? ((activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(tail(tail(currentUrl))))), (activePatternResult_1 != null) ? (!isEmpty(tail(tail(tail(tail(currentUrl))))) ? ((head(tail(tail(tail(tail(currentUrl))))) === "machine") ? (!isEmpty(tail(tail(tail(tail(tail(currentUrl)))))) ? ((activePatternResult_2 = Route_$007CInt$007C_$007C(head(tail(tail(tail(tail(tail(currentUrl))))))), (activePatternResult_2 != null) ? ((id = (activePatternResult_2 | 0), (pathCustomerId = (activePatternResult_1 | 0), (pathGroupId = (activePatternResult | 0), [((pathGroupId === groupId) && (pathCustomerId === customerId)) && (id === machine.Id), tail(tail(tail(tail(tail(tail(currentUrl))))))])))) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()]) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()]) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()];
    const selected_1 = patternInput[0];
    useEffectWithDeps(() => {
        let active = true;
        if (selected_1) {
            const elem = document.getElementById(key);
            const pr = new Promise(resolve => setTimeout(resolve, 250));
            pr.then(() => {
                if (active) {
                    console.debug("Opened machine hierarchy item", elem.id, "so scrolling to it");
                    elem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        }
        return createDisposable(() => {
            console.debug("[HierarchySidebar] Disposing MachineItem");
            active = false;
        });
    }, []);
    return createElement(Components_CompanyHierarchyItem_Z538FBA19, {
        key: key,
        $key: key,
        name: machineName,
        isOpen: true,
        isFavorite: machine.Favorite,
        onClick: () => {
            const newUrl = append(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), "machine", int32ToString(machine.Id)]), patternInput[1]);
            if (ctx.SidebarOpen) {
                ctx.SetSidebarOpen(false);
            }
            RouterModule_nav(ofArray(toArray(newUrl)), 1, 1);
        },
        onExpand: () => {
        },
        onFavorite: () => {
            dispatch(machine.Favorite ? (new Message(7, [groupId, customerId, machine])) : (new Message(4, [groupId, customerId, machine])));
        },
        selected: selected_1,
        withChildren: false,
        sx: some({
            pl: 10,
        }),
    });
}

export const Components_CustomerItem_7AAEF5C5 = memo((components_CustomerItem_7AAEF5C5InputProps) => {
    let activePatternResult, activePatternResult_1, id, pathGroupId, activePatternResult_2, activePatternResult_3, id_1, pathGroupId_1, elements_2, elements_1, elements;
    const customer = components_CustomerItem_7AAEF5C5InputProps.customer;
    const groupId = components_CustomerItem_7AAEF5C5InputProps.groupId;
    const key = components_CustomerItem_7AAEF5C5InputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const companyHierarchy = reactApi.useContext(hierarchyContext);
    const dispatch = reactApi.useContext(dispatchContext);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const childSelected = !isEmpty(currentUrl) && ((head(currentUrl) === "group") && (!isEmpty(tail(currentUrl)) && ((activePatternResult = Route_$007CInt$007C_$007C(head(tail(currentUrl))), (activePatternResult != null) && (!isEmpty(tail(tail(currentUrl))) && ((head(tail(tail(currentUrl))) === "customer") && (!isEmpty(tail(tail(tail(currentUrl)))) && ((activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(tail(tail(currentUrl))))), (activePatternResult_1 != null) && (!isEmpty(tail(tail(tail(tail(currentUrl))))) && ((head(tail(tail(tail(tail(currentUrl))))) === "machine") && ((id = (activePatternResult_1 | 0), (pathGroupId = (activePatternResult | 0), (pathGroupId === groupId) && (id === customer.Id)))))))))))))));
    const selected_1 = (!isEmpty(currentUrl) ? ((head(currentUrl) === "group") ? (!isEmpty(tail(currentUrl)) ? ((activePatternResult_2 = Route_$007CInt$007C_$007C(head(tail(currentUrl))), (activePatternResult_2 != null) ? (!isEmpty(tail(tail(currentUrl))) ? ((head(tail(tail(currentUrl))) === "customer") ? (!isEmpty(tail(tail(tail(currentUrl)))) ? ((activePatternResult_3 = Route_$007CInt$007C_$007C(head(tail(tail(tail(currentUrl))))), (activePatternResult_3 != null) ? ((id_1 = (activePatternResult_3 | 0), (pathGroupId_1 = (activePatternResult_2 | 0), [!isEmpty(tail(tail(tail(tail(currentUrl))))) ? ((head(tail(tail(tail(tail(currentUrl))))) === "machine") ? false : ((pathGroupId_1 === groupId) && (id_1 === customer.Id))) : ((pathGroupId_1 === groupId) && (id_1 === customer.Id)), tail(tail(tail(tail(currentUrl))))]))) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()]) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()])[0];
    const patternInput_1 = reactApi.useState(childSelected);
    const setOpen = patternInput_1[1];
    const isOpen = patternInput_1[0];
    useEffectWithDeps(() => {
        let active = true;
        if (selected_1) {
            const elem = document.getElementById(key);
            const pr = new Promise(resolve => setTimeout(resolve, 250));
            pr.then(() => {
                if (active) {
                    console.debug("Opened customer hierarchy item", elem.id, "so scrolling to it");
                    elem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        }
        return createDisposable(() => {
            console.debug("[HierarchySidebar] Disposing MachineItem");
            active = false;
        });
    }, []);
    const dependencies_1 = [companyHierarchy.SearchTerm];
    reactApi.useEffect(() => {
        if ((!isOpen && !isNullOrWhiteSpace(companyHierarchy.SearchTerm)) && !(customer.Machines.length === 0)) {
            setOpen(true);
        }
    }, dependencies_1);
    const xs_1 = [createElement(Components_CompanyHierarchyItem_Z538FBA19, {
        key: key,
        $key: key,
        name: customer.Name,
        isOpen: isOpen,
        isFavorite: customer.Favorite,
        onClick: () => {
            let newUrl;
            const root = ofArray(["group", int32ToString(groupId), "customer", int32ToString(customer.Id)]);
            let matchResult;
            if (!isEmpty(currentUrl)) {
                if (head(currentUrl) === "group") {
                    if (!isEmpty(tail(currentUrl))) {
                        if (Route_$007CInt$007C_$007C(head(tail(currentUrl))) != null) {
                            if (!isEmpty(tail(tail(currentUrl)))) {
                                if (head(tail(tail(currentUrl))) === "customer") {
                                    if (!isEmpty(tail(tail(tail(currentUrl))))) {
                                        if (Route_$007CInt$007C_$007C(head(tail(tail(tail(currentUrl))))) != null) {
                                            if (!isEmpty(tail(tail(tail(tail(currentUrl)))))) {
                                                if (head(tail(tail(tail(tail(currentUrl))))) === "machine") {
                                                    matchResult = 0;
                                                }
                                                else {
                                                    matchResult = 1;
                                                }
                                            }
                                            else {
                                                matchResult = 1;
                                            }
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    newUrl = root;
                    break;
                }
                default: {
                    let matchResult_1, rest_2;
                    if (!isEmpty(currentUrl)) {
                        if (head(currentUrl) === "group") {
                            if (!isEmpty(tail(currentUrl))) {
                                if (Route_$007CInt$007C_$007C(head(tail(currentUrl))) != null) {
                                    if (!isEmpty(tail(tail(currentUrl)))) {
                                        if (head(tail(tail(currentUrl))) === "customer") {
                                            if (!isEmpty(tail(tail(tail(currentUrl))))) {
                                                if (Route_$007CInt$007C_$007C(head(tail(tail(tail(currentUrl))))) != null) {
                                                    matchResult_1 = 0;
                                                    rest_2 = tail(tail(tail(tail(currentUrl))));
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_1 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            newUrl = append(root, rest_2);
                            break;
                        }
                        default:
                            newUrl = root;
                    }
                }
            }
            if (ctx.SidebarOpen) {
                ctx.SetSidebarOpen(false);
            }
            RouterModule_nav(ofArray(toArray(newUrl)), 1, 1);
        },
        onExpand: () => {
            setOpen(!isOpen);
        },
        onFavorite: () => {
            dispatch(customer.Favorite ? ((console.debug("Remove favorite customer", customer), new Message(5, [groupId, customer]))) : ((console.debug("Favorite customer", customer), new Message(2, [groupId, customer]))));
        },
        expandDisabled: customer.Machines.length === 0,
        selected: selected_1,
        withChildren: true,
        sx: some({
            pl: 4,
        }),
    }), MuiHelpers_createElement(Collapse, [["mountOnEnter", true], ["unmountOnExit", false], ["in", isOpen], (elements_2 = [MuiHelpers_createElement(List, [(elements_1 = ((customer.Machines.length === 0) ? singleton(MuiHelpers_createElement(ListItem, [["sx", {
        pl: 8,
    }], (elements = [MuiHelpers_createElement(ListItemText, [["primary", MuiHelpers_createElement(Typography, [["style", {
        fontSize: 12 + "px",
    }], ["variant", "body2"], ["children", createElement("i", {
        children: ["Ingen maskiner"],
    })]])]])], ["children", reactApi.Children.toArray(Array.from(elements))])])) : map((machine) => {
        const $key30993F4E = `${groupId}-${customer.Id}-${machine.Id}`;
        return createElement(Components_MachineItem_6F13676, {
            key: $key30993F4E,
            $key: $key30993F4E,
            groupId: groupId,
            customerId: customer.Id,
            machine: machine,
        });
    }, sortBy((_arg) => _arg.Name, customer.Machines, {
        Compare: comparePrimitives,
    }))), ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])];
    return react.createElement(react.Fragment, {}, ...xs_1);
});

function Components_GroupItem_Z292E76B7(components_GroupItem_Z292E76B7InputProps) {
    let activePatternResult, groupId, activePatternResult_1, groupId_1, elements_1, elements;
    const group = components_GroupItem_Z292E76B7InputProps.group;
    const key = components_GroupItem_Z292E76B7InputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const companyHierarchy = reactApi.useContext(hierarchyContext);
    const dispatch = reactApi.useContext(dispatchContext);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const childSelected = !isEmpty(currentUrl) && ((head(currentUrl) === "group") && (!isEmpty(tail(currentUrl)) && ((activePatternResult = Route_$007CInt$007C_$007C(head(tail(currentUrl))), (activePatternResult != null) && ((groupId = (activePatternResult | 0), !isEmpty(tail(tail(currentUrl))) && ((head(tail(tail(currentUrl))) === "machine") ? (groupId === group.Id) : ((head(tail(tail(currentUrl))) === "customer") && (groupId === group.Id)))))))));
    const patternInput = !isEmpty(currentUrl) ? ((head(currentUrl) === "group") ? (!isEmpty(tail(currentUrl)) ? ((activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(currentUrl))), (activePatternResult_1 != null) ? ((groupId_1 = (activePatternResult_1 | 0), [!isEmpty(tail(tail(currentUrl))) ? ((head(tail(tail(currentUrl))) === "machine") ? false : ((head(tail(tail(currentUrl))) === "customer") ? false : (groupId_1 === group.Id))) : (groupId_1 === group.Id), tail(tail(currentUrl))])) : [false, empty()])) : [false, empty()]) : [false, empty()]) : [false, empty()];
    const selected_2 = patternInput[0];
    let patternInput_1;
    const initial = ((group.Customers.length > 0) && selected_2) ? true : childSelected;
    patternInput_1 = reactApi.useState(initial);
    const setOpen = patternInput_1[1];
    const isOpen = patternInput_1[0];
    useEffectWithDeps(() => {
        let active = true;
        if (selected_2) {
            const elem = document.getElementById(key);
            const pr = new Promise(resolve => setTimeout(resolve, 250));
            pr.then(() => {
                if (active) {
                    console.debug("Opened group hierarchy item", elem.id, "so scrolling to it");
                    elem.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            });
        }
        return createDisposable(() => {
            console.debug("[HierarchySidebar] Disposing GroupItem");
            active = false;
        });
    }, []);
    const dependencies_1 = [companyHierarchy.SearchTerm];
    reactApi.useEffect(() => {
        if ((!isOpen && !isNullOrWhiteSpace(companyHierarchy.SearchTerm)) && !(group.Customers.length === 0)) {
            const elem_1 = document.getElementById(key);
            console.debug("Opened hierarchy item", elem_1);
            setOpen(true);
        }
    }, dependencies_1);
    const xs_1 = [createElement(Components_CompanyHierarchyItem_Z538FBA19, {
        key: key,
        $key: key,
        name: group.Name,
        isOpen: isOpen,
        isFavorite: group.Favorite,
        onClick: () => {
            console.debug("Navigate to group", group.Id);
            let url;
            const root = ofArray(["group", int32ToString(group.Id)]);
            let matchResult;
            if (!isEmpty(currentUrl)) {
                if (head(currentUrl) === "group") {
                    if (!isEmpty(tail(currentUrl))) {
                        if (Route_$007CInt$007C_$007C(head(tail(currentUrl))) != null) {
                            if (!isEmpty(tail(tail(currentUrl)))) {
                                if (head(tail(tail(currentUrl))) === "customer") {
                                    matchResult = 0;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    url = root;
                    break;
                }
                default: {
                    let matchResult_1;
                    if (!isEmpty(currentUrl)) {
                        if (head(currentUrl) === "group") {
                            matchResult_1 = 0;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            url = append(root, patternInput[1]);
                            break;
                        }
                        default:
                            url = root;
                    }
                }
            }
            if (ctx.SidebarOpen) {
                ctx.SetSidebarOpen(false);
            }
            RouterModule_nav(ofArray(toArray(url)), 1, 1);
        },
        onExpand: () => {
            setOpen(!isOpen);
        },
        onFavorite: () => {
            console.debug("Favorite group", group);
            dispatch(group.Favorite ? (new Message(6, [group])) : (new Message(3, [group])));
        },
        expandDisabled: group.Customers.length === 0,
        selected: selected_2,
        withChildren: true,
    }), MuiHelpers_createElement(Collapse, [["mountOnEnter", true], ["unmountOnExit", true], ["in", isOpen], (elements_1 = [MuiHelpers_createElement(List, [["dense", true], (elements = map((customer) => {
        Components_CustomerItem_7AAEF5C5.displayName = "Components_CustomerItem_7AAEF5C5";
        const $key27DEDFA2 = `${group.Id}-${customer.Id}`;
        return createElement(Components_CustomerItem_7AAEF5C5, {
            key: $key27DEDFA2,
            $key: $key27DEDFA2,
            groupId: group.Id,
            customer: customer,
        });
    }, sortBy((_arg) => _arg.Name, group.Customers, {
        Compare: comparePrimitives,
    })), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Components_CompanyHierarchySidebar_3A59D1F3(components_CompanyHierarchySidebar_3A59D1F3InputProps) {
    let elems_3, elems_1, elems, elems_2;
    const onClose = components_CompanyHierarchySidebar_3A59D1F3InputProps.onClose;
    const key = components_CompanyHierarchySidebar_3A59D1F3InputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const dispatch = reactApi.useContext(dispatchContext);
    const responsive = useResponsive(undefined);
    const customerOverviewHeaderRef = reactApi.useRef(undefined);
    const timer = reactApi.useRef(0);
    const favorites = choose(Helpers_collectFavorites, hierarchy.Groups);
    const chooseGroups = (group_1) => {
        let $keyZ61C4BF45;
        const searchTerm = hierarchy.SearchTerm;
        const filteredCustomers = choose((customer) => Helpers_filterCustomers(searchTerm, customer), group_1.Customers);
        if (group_1.Enabled && ((isNullOrWhiteSpace(searchTerm) ? true : strIContains(searchTerm, group_1.Name)) ? true : !(filteredCustomers.length === 0))) {
            const filtered = new CustomerGroupWithMembers(group_1.Id, group_1.Name, group_1.Enabled, group_1.IsMain, group_1.IsPtg, group_1.Favorite, group_1.Company, filteredCustomers);
            return ($keyZ61C4BF45 = int32ToString(group_1.Id), createElement(Components_GroupItem_Z292E76B7, {
                key: $keyZ61C4BF45,
                $key: $keyZ61C4BF45,
                group: filtered,
            }));
        }
        else {
            return undefined;
        }
    };
    let pinIcon;
    const props_1 = {
        style: {
            transform: ("rotate(" + -20) + "deg)",
        },
    };
    pinIcon = react.createElement(PushPin, props_1);
    return createElement("div", createObj(ofArray([["id", "customer-overview"], ["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_3 = [createElement("div", createObj(ofArray([["id", "customer-overview-header"], ["ref", customerOverviewHeaderRef], ["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems = toList(delay(() => append_1(singleton_1(MuiHelpers_createElement(Typography, [["variant", "h4"], ["sx", {
        flexGrow: 1,
    }], ["children", ctx.Locale.t("CustomerSite.Sidebar.Title")]])), delay(() => {
        let props_8, props_4;
        const matchValue = responsive;
        switch (matchValue) {
            case "desktop":
                return singleton_1(MuiHelpers_createElement(Tooltip, [["title", ctx.Locale.t("CustomerSite.Sidebar.Hide")], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
                    ctx.SetHideSidebar(!ctx.HideSidebar);
                    if (ctx.SidebarOpen) {
                        ctx.SetSidebarOpen(false);
                    }
                }], ["children", (props_8 = {}, react.createElement(MenuOpen, props_8))]])]]));
            case "wideScreen":
                return singleton_1(defaultOf());
            default:
                return singleton_1(MuiHelpers_createElement(Tooltip, [["title", ctx.Locale.t("CustomerSite.Sidebar.Close")], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
                    onClose();
                }], ["children", (props_4 = {}, react.createElement(Close, props_4))]])]]));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Typography, [["sx", {
        color: "var(--dark-grey)",
    }], ["paragraph", false], ["variant", "subtitle2"], ["children", ctx.Locale.t("CustomerSite.Sidebar.Desc")]]), createElement(Components_Searchbar_25F45B5E, {
        placeholder: ctx.Locale.t("CompanyHierarchy.Search"),
        onChange: (ev) => {
            const str = ev.target.value;
            if (isNullOrWhiteSpace(str) ? true : (str.length >= 3)) {
                debounce_1(750, timer, () => {
                    dispatch(new Message(9, [str]));
                });
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["flexDirection", "column"]), delay(() => append_1(singleton_1(["overflowY", "scroll"]), delay(() => append_1(singleton_1(["rowGap", 15 + "px"]), delay(() => {
        let headerHeight;
        return ((responsive === "desktop") ? true : (responsive === "wideScreen")) ? singleton_1(["height", ("calc(" + ((headerHeight = defaultArg(map_1((elem) => elem.clientHeight, customerOverviewHeaderRef.current), 132), `100vh - ${defaultArg(map_1((elem_1) => {
            const div = elem_1;
            return div.clientHeight;
        }, tryGetById("top-bar")), 120)}px - ${headerHeight}px - 60px`))) + ")"]) : empty_1();
    })))))))))))], (elems_2 = toList(delay(() => (!hierarchy.GroupsFetched ? singleton_1(listLoadingIndicator(30)) : append_1(singleton_1(createElement(Components_TreeContainer_4089C375, {
        key: "favorites",
        $key: "favorites",
        title: ctx.Locale.t("CustomerSite.Sidebar.MyShortcuts"),
        titleIcon: pinIcon,
        listItems: choose(chooseGroups, favorites),
    })), delay(() => {
        let props_15;
        return singleton_1(createElement(Components_TreeContainer_4089C375, {
            key: "all-groups",
            $key: "all-groups",
            title: ctx.Locale.t("CustomerSite.Sidebar.AllCustomers"),
            titleIcon: (props_15 = {}, react.createElement(People, props_15)),
            listItems: choose(chooseGroups, hierarchy.Groups),
        }));
    }))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

